<template>
	<div class="list-page none-select mask" v-if="questionList.list">
		<!-- 进度条 -->
		<div class="row progress" :style="{ width: ((current + 1) / questionList.list.length) * 100 + '%' }"></div>
		<!-- 进度题号 -->
		<div class="row progress-text page-padding">
			<div class="row num-text">
				<span class="current">{{ current + 1 }}</span>
				<span>/</span>
				<span>{{ questionList.list.length }}</span>
			</div>
			<div class="row clock-view" v-if="countText">
				<img src="@/assets/question/clock.png" />
				<span>倒计时{{ countText }}</span>
			</div>
		</div>
		<!-- 题号 -->
		<div class="row page-padding title-view">
			<div class="row tags">{{ questionList.list[current].type === 2 ? '多选' : '单选' }}</div>
			<div class="row title">{{ questionList.list[current].title }}</div>
		</div>
		<!-- 选项 -->
		<div class="col page-padding options-view">
			<!-- current-bg -->
			<!-- right-bg -->
			<div class="row options-item link" v-for="(item, index) in questionList.list[current].options" :key="index" @click="tapOptions(index)">
				<span
					:class="{
						'current-bg':
							answerIndex.indexOf(index) !== -1 ||
							(questionList.list[current].answer_info && questionList.list[current].answer_info.stu_letter_answer.split(',').indexOf(item.letter) !== -1),
						'right-bg': questionList.list[current].answer_info && questionList.list[current].answer_info.right_letter_answer.split(',').indexOf(item.letter) !== -1
					}"
				>
					{{ item.letter }}
				</span>
				<span>{{ item.text }}</span>
			</div>
		</div>
		<template v-if="questionList.list[current].answer_info">
			<!-- 正确答案 -->
			<div class="row answer-view">
				<div class="row">
					<span>您的答案：</span>
					<span class="current-color">{{ questionList.list[current].answer_info.stu_letter_answer }}</span>
				</div>
				<div class="row">
					<span>正确答案：</span>
					<span class="right-color">{{ questionList.list[current].answer_info.right_letter_answer }}</span>
				</div>
			</div>
			<!-- 解析 -->
			<div class="row analyse page-padding" v-show="questionList.list[current].answer_info.narrate">
				<div class="row">参考解析：</div>
				<div class="row">{{ questionList.list[current].answer_info.narrate }}</div>
			</div>
			<!-- 按钮组 -->
			<div class="row btn-view">
				<div class="row btn-item link" :class="{ disable: disPrevious }" @click="tapPrevious">上一题</div>
				<div class="row btn-item link" :class="{ disable: disNext }" @click="tapNext">下一题</div>
			</div>
		</template>
		<template v-else>
			<div class="row btn-view link"><div class="row btn-item" @click="mode === 'exam' ? subExam() : subMock()">提交</div></div>
		</template>
		<div class="right-count-wrap"></div>
		<div class="row right-count page-padding">
			<div>
				<span>已答对</span>
				<span class="count-text right-color">{{ questionList.progress.right_count }}</span>
				<span>道题；</span>
			</div>
			<div>
				<span>已答错</span>
				<span class="count-text error-color">{{ questionList.progress.error_count }}</span>
				<span>道题</span>
			</div>
		</div>
		<!-- 弹出层 -->
		<el-dialog class="result-dialog" width="8.08rem" :visible="showDialog" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
			<img src="~@/assets/pass.png" alt="" />
			<p>{{ dialogModel === 'success' ? '恭喜您，考试通过！' : '很遗憾，考试未通过！' }}</p>
			<p>{{ dialogModel === 'success' ? '请登录华培网查看证书信息' : '请您认真准备下次考试' }}</p>
			<div class="btn" @click="confirmDialog">确认</div>
		</el-dialog>
	</div>
</template>

<script>
let Interval = '';
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	computed: {
		disPrevious() {
			return this.current === 0;
		},
		disNext() {
			return this.current === this.questionList.list.length - 1 && this.mode === 'exam';
		}
	},
	data() {
		return {
			showDialog: false,
			dialogModel: 'success',
			current: 0,
			questionList: [],
			countText: '',
			answerIndex: []
		};
	},
	created() {
		if (!this.$store.getters.getToken) {
			this.navToForbidden();
		} else {
			if (this.mode === 'exam') {
				Interval = setInterval(() => {
					this.countdown();
				}, 1000);
				this.service2('client/exam/question', { exam_log_id: this.$route.query.id }).then(res => {
					this.questionList = res.data;
					this.current = res.data.progress.current - 1;
				});
			} else {
				this.fetchMockQuestion();
			}
		}
	},
	beforeDestroy() {
		// 清空倒计时
		clearInterval(Interval);
	},
	methods: {
		navToForbidden() {
			this.$router.replace({
				path: '/' + this.mode + '/login'
			});
		},
		fetchMockQuestion() {
			this.service2('client/mock/question', { order_id: this.$route.query.id }).then(res => {
				this.questionList = res.data;
				this.current = res.data.progress.current - 1;
			});
		},
		tapPrevious() {
			if (this.disPrevious) return;
			this.current--;
			this.answerIndex = [];
		},
		tapNext() {
			if (this.disNext) return;

			this.answerIndex = [];
			if (this.mode === 'mock' && this.current === this.questionList.list.length - 1) {
				// 练习模式最后一题时，从头再来！
				this.fetchMockQuestion();
			} else {
				this.current++;
			}
		},
		// 答案提交（练习模式）
		subMock() {
			if (this.answerIndex.length === 0) return;
			this.service2('client/mock/submit', {
				uuid: this.questionList.uuid,
				question_version_id: this.questionList.question_version_id,
				order_id: this.questionList.order_id,
				q_id: this.questionList.list[this.current].id,
				stu_answer: this.answerIndex
			}).then(res => {
				res.data.result == 1 ? this.questionList.progress.right_count++ : this.questionList.progress.error_count++;
				this.$set(this.questionList.list[this.current], 'answer_info', res.data);
			});
		},
		// 答案提交（考试模式）
		subExam() {
			if (this.answerIndex.length === 0) return;
			this.service2('client/exam/submit', {
				exam_log_id: this.questionList.exam_log_id,
				question_version_id: this.questionList.question_version_id,
				q_id: this.questionList.list[this.current].id,
				stu_answer: this.answerIndex
			}).then(res => {
				if (res.data.exam_log_status === 1) {
					// this.showDialog = true;
					// this.dialogModel = 'success';
					this.$router.replace({
						name: this.mode,
						params: {
							name: 'success'
						},
						query: {
							score: res.data.score
						}
					});
				} else if (res.data.exam_log_status === 2) {
					// this.showDialog = true;
					// this.dialogModel = 'fail';
					this.$router.replace({
						name: this.mode,
						params: {
							name: 'fail'
						}
						// query: {
						// 	score: res.data.score
						// }
					});
				} else {
					this.showDialog = false;
					this.dialogModel = '';
				}
				res.data.result == 1 ? this.questionList.progress.right_count++ : this.questionList.progress.error_count++;
				this.$set(this.questionList.list[this.current], 'answer_info', res.data);
			});
		},
		// 点击选项时
		tapOptions(index) {
			if (this.questionList.list[this.current].answer_info) return;
			if (this.answerIndex.indexOf(index) !== -1) {
				this.answerIndex.splice(this.answerIndex.indexOf(index), 1);
			} else {
				if (this.questionList.list[this.current].type === 2) {
					this.answerIndex.push(index);
				} else {
					this.answerIndex = [index];
				}
			}
		},
		//倒计时
		countdown() {
			let end_time = this.questionList.countdown_time; //终止时间
			var curr_time = parseInt(Date.parse(new Date()) / 1000);
			var diff_time = parseInt(end_time - curr_time); // 倒计时时间差
			var h = Math.floor(diff_time / 3600);
			var m = Math.floor((diff_time / 60) % 60);
			var s = Math.floor(diff_time % 60);
			let countText = '';
			countText = h + ':' + m + ':' + s;
			if (diff_time <= 0) {
				clearInterval(Interval);
				countText = '0:0';
				if (this.$store.getters.isPc) {
					this.$alert('考试已结束，本次考试超时未提交，请认真准备下次考试！', '考试结束', {
						confirmButtonText: '确认',
						callback: action => {
							this.$router.replace({
								name: this.mode,
								params: {
									name: 'choice'
								}
							});
						}
					});
				} else {
					this.$dialog
						.alert({
							title: '考试结束',
							message: '考试已结束，本次考试超时未提交，请认真准备下次考试！'
						})
						.then(() => {
							this.$router.replace({
								name: this.mode,
								params: {
									name: 'choice'
								}
							});
						});
				}
			}
			// console.log(countText);
			this.countText = countText;
		},
		// 点击确定 - 关闭弹层
		confirmDialog() {
			this.$nextTick(() => {
				if (this.$store.getters.isPc) {
					// pc端退回首页
					this.$router.replace({
						path: '/'
					});
				} else {
					// 手机端跳转至登录
					this.$store.dispatch('logout');
					this.$router.replace({
						path: '/exam/login'
					});
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
@import './List.less';
</style>
